import Translations from "translations/types";

export const SHARE_PATIENT_DATE_KEY = "share_patient_data" as const;

const SHARE_PATIENT_DATE_STEPS = {
  GRANT_ACCESS: "grant_access",
  KEEP_OVERVIEW: "keep_overview",
  TRACK_CHANGES: "track_changes",
} as const;

export const ACCESS_TO_PATIENT_DATE = {
  key: SHARE_PATIENT_DATE_KEY,
  steps: {
    [SHARE_PATIENT_DATE_STEPS.GRANT_ACCESS]: {
      intro: (t: Translations) => t.tours.accessPatientData.stepB.text,
      key: SHARE_PATIENT_DATE_STEPS.GRANT_ACCESS,
      step: 2,
      title: (t: Translations) => t.tours.accessPatientData.stepB.title,
    },
    [SHARE_PATIENT_DATE_STEPS.KEEP_OVERVIEW]: {
      intro: (t: Translations) => t.tours.accessPatientData.stepA.text,
      key: SHARE_PATIENT_DATE_STEPS.KEEP_OVERVIEW,
      step: 1,
      title: (t: Translations) => t.tours.accessPatientData.stepA.title,
    },
    [SHARE_PATIENT_DATE_STEPS.TRACK_CHANGES]: {
      intro: (t: Translations) => t.tours.accessPatientData.stepC.text,
      key: SHARE_PATIENT_DATE_STEPS.TRACK_CHANGES,
      position: "left",
      step: 3,
      title: (t: Translations) => t.tours.accessPatientData.stepC.title,
    },
  },
} as const;
